// Carrega o Google Tag Manager e o GA4 so no site de producao.
//
// O .env e versionado no git, entao todo build do Netlify (producao,
// deploy preview e branch deploy) recebe os mesmos IDs. Por isso, alem
// do ID estar definido, o dominio precisa ser o de producao: assim
// localhost, homolog e as versoes de teste do Netlify nao enviam dados
// pra conta real.

const PRODUCTION_HOSTS = ['worsheep.netlify.app'];

const isProduction = () => PRODUCTION_HOSTS.includes(window.location.hostname);

const loadGoogleTagManager = (gtmId) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  const noscript = document.createElement('noscript');
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
};

const loadGoogleAnalytics = (ga4Id) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // O gtag espera receber o objeto arguments, nao um array.
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', ga4Id);
};

export const loadAnalytics = () => {
  if (!isProduction()) return;

  const gtmId = process.env.REACT_APP_GTM_ID;
  const ga4Id = process.env.REACT_APP_GA4_ID;

  if (gtmId) loadGoogleTagManager(gtmId);
  if (ga4Id) loadGoogleAnalytics(ga4Id);
};
